module.exports = __webpack_public_path__ + "static/media/account.afaf9c1b.svg";